// extracted by mini-css-extract-plugin
export default {"appSearchBar":"AppSearchBar_appSearchBar__0rW9v","searchBtn":"AppSearchBar_searchBtn__8A2R-"};